import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/admin/solicitudes',
    name: 'leads.index',
    component: () => import('./views/SolicitudesIndex.vue'),
    meta: {
      layout: 'auth',
      requiresAuth: true,
      requiresPermission: 'leads.read',
      breadcrumb: 'Solicitudes',
    },
  },
]

export default routes
